((Accordion, $) => {
  "use strict";
  const $dom = {};
  const selectors = {};
  const cacheSelectors = () => {
    selectors.accordion = `[data-accordion]`;
    selectors.accordionItem = `[data-accordion-item]`;
    selectors.accordionToggle = `[data-accordion-toggle]`;
    selectors.accordionContent = `[data-accordion-content]`;
  };
  const cacheDom = () => {
    $dom.accordion = $(selectors.accordion);
    $dom.accordionToggle = $(selectors.accordionToggle);
  };

  const toggleAccordion = (el) => {
    const $accordionToggle = $(el);
    const $accordionItem = $accordionToggle.closest(selectors.accordionItem);
    const $accordion = $accordionItem.closest(selectors.accordion);
    const isInitiallyOpen = $accordionItem.data(`accordion-open`);

    $accordion.find(selectors.accordionItem).each((idx, accordionItem) => {
      $(accordionItem).data(`accordion-open`, false).attr(`data-accordion-open`, false);
      $(accordionItem).find(selectors.accordionContent).slideUp();
    });

    if (isInitiallyOpen) {
      return;
    }

    $accordionItem.data(`accordion-open`, true).attr(`data-accordion-open`, true);
    $accordionItem.find(selectors.accordionContent).slideDown();
  };

  const bindUIActions = () => {
    $dom.accordionToggle.on(`click`, event => {
      event.preventDefault();
      toggleAccordion(event.currentTarget);
    });
  };

  const init = () => {
    cacheSelectors();
    cacheDom();
    bindUIActions();
  };

  Accordion.init = init
})((window.Accordion = window.Accordion || {}), jQuery);